var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.schoolGroupTrendAnalysisHumanitiesOrSciences)?_c('Row',[_c('i-col',{attrs:{"offset":"5","span":"16"}},[_c('g-trend-analysis-humanities-or-sciences-chart',{attrs:{"data":_vm.schoolGroupTrendAnalysisHumanitiesOrSciences}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }